import { querySharedServices } from '@/src/domains/shared/services';
import { queryBenefitsDirectoryPage } from '@/src/views/BenefitsDirectory/services';

export { BenefitsDirectoryPage as default } from '@/src/views/BenefitsDirectory';

export async function getStaticProps({ preview = false, previewData = {}, locale }) {
  const dataContent = await queryBenefitsDirectoryPage({ previewData, locale });

  if (!dataContent) {
    return {
      notFound: true,
    };
  }

  const sharedServices = await querySharedServices({ previewData, locale });

  return {
    props: {
      ...dataContent,
      preview,
      sharedServices,
    },
  };
}
